<template>
    <ui-container class="py-8 space-y-8">
        <!-- Header. -->
        <ui-header :title="`Supplier Quote `" :subtitle="'ID #'+this.supplierQuote.id">
            <template #actions>
                <ui-dropdown placement="bottom-end" menu-class="p-3 w-64">
                    <template #default="{ toggle }">
                        <ui-button-new @click="toggle" primary>
                            Actions
                            <i class="flex-shrink-0 ml-2 fa fa-chevron-down"></i>
                        </ui-button-new>
                    </template>
                    <template #menu="{ close }">
                        <ui-dropdown-item icon="fas fa-calculator"
                                          @click="edit()">
                            Edit
                        </ui-dropdown-item>
                        <ui-dropdown-divider></ui-dropdown-divider>
                        <ui-dropdown-item icon="fa fa-copy"
                                          @click="copy(); close();">Copy Supplier Quote
                        </ui-dropdown-item>
                        <ui-dropdown-divider></ui-dropdown-divider>
                        <ui-dropdown-item danger icon="fa fa-trash"
                                          @click="openDeleteModal">Delete
                        </ui-dropdown-item>
                    </template>
                </ui-dropdown>
            </template>
        </ui-header>
        <ui-tabs active="overview" :tabs="tabs" #default="{ isActive }">
            <!-- Overview. -->
            <div v-if="isActive('overview')">

                <ui-data-grid>
                    <ui-data-grid-item label="Supplier" class="sm:col-span-full"
                                       :value="supplierQuote.supplierName"></ui-data-grid-item>
                    <ui-data-grid-item label="Valid From" :value="supplierQuote.validFrom"></ui-data-grid-item>
                    <ui-data-grid-item label="Valid To" :value="supplierQuote.validTo"></ui-data-grid-item>
                </ui-data-grid>

                <div class="border-b -mb-px border-gray-200 mt-8">
                    <div class="flex border-t -mb-px border-gray-200 bg-gray-50 text-gray-500">
                        <div class="w-6 flex-shrink-0"></div>
                        <div class="flex-1 border-r border-gray-200 px-2 py-1 text-xs font-semibold">Item</div>
                        <div class="w-20 -ml-px border-r border-gray-200 px-2 py-1 text-xs font-semibold">Type</div>
                        <div class="w-14 -ml-px border-r border-gray-200 px-2 py-1 text-xs font-semibold">UoM</div>
                        <div class="w-24 -ml-px border-r border-gray-200 px-2 py-1 text-xs font-semibold">Cost per
                            Unit
                        </div>
                        <div class="w-6 ml-2 flex-shrink-0"></div>
                    </div>
                    <div class="flex border-t -my-px" v-for="(i) in supplierQuote.items">
                        <div class="w-6 flex-shrink-0"></div>
                        <div class="flex-1 -ml-px flex text-sm -my-px px-2 py-1.5 border-l border-gray-200">
                            <div style="white-space: pre-wrap">{{ i.name }}</div>
                        </div>
                        <div
                            class="w-20 -ml-px flex text-sm -my-px px-2 py-1.5 border-l border-gray-200 text-xs">
                            <div style="white-space: pre-wrap">{{ i.type }}</div>
                        </div>
                        <div class="w-14 -ml-px flex text-sm -my-px px-2 py-1.5 border-l border-gray-200">
                            <div style="white-space: pre-wrap">{{ i.unitOfMeasure }}</div>
                        </div>
                        <div class="w-24 -ml-px flex text-sm -my-px px-2 py-1.5 border-l border-r border-gray-200">
                            <div style="white-space: pre-wrap">{{ i.costPerUnit }}</div>
                        </div>
                        <div class="w-6 ml-2 flex-shrink-0"></div>
                    </div>
                </div>
                <ui-data-grid-item label="Quick action" wide class="mt-4">
                    <div class="flex flex-col md:flex-row flex-wrap -m-2">
                        <ui-button-new class="m-2" icon="fas fa-copy" @click="duplicate" success>Duplicate as new
                            Supplier
                            Quote
                        </ui-button-new>
                    </div>
                </ui-data-grid-item>
                <ui-data-grid class="mt-8">
                    <ui-data-grid-item label="Created By">{{ supplierQuote.createdBy }} on {{
                            supplierQuote.createdOn
                        }}
                    </ui-data-grid-item>
                    <ui-data-grid-item label="Last Updated By" v-if="supplierQuote.lastUpdatedBy">{{
                            supplierQuote.lastUpdatedBy
                        }} on {{ supplierQuote.lastUpdatedOn }}
                    </ui-data-grid-item>
                </ui-data-grid>
            </div>
            <div v-else-if="isActive('files')">
                <fs filesystem-title="" path="" :filesystem-id="supplierQuote.filesystemId"></fs>
            </div>
        </ui-tabs>

    </ui-container>
</template>

<script>
import AutoresizableTextarea from "../ui/AutoresizableTextarea";
import UiContainer from "../ui/UiContainer.vue";
import UiDropdownItem from "../ui/UiDropdownItem.vue";
import UiDropdown from "../ui/UiDropdown.vue";
import UiButtonNew from "../ui/UiButtonNew.vue";
import UiDataGrid from "../ui/UiDataGrid.vue";
import UiDataGridItem from "../ui/UiDataGridItem.vue";
import SupplierQuotesItem from "./SupplierQuotesItem.vue";
import SupplierQuotesMaterialSearch from "./SupplierQuotesMaterialSearch.vue";
import {SupplierQuote} from "@models";
import Fs from "../filesystem/Fs.vue";
import {cloneDeep} from "lodash";
import remoteStorage from "../../utils/remoteStorage";

export default {
    components: {
        Fs,
        SupplierQuotesMaterialSearch,
        SupplierQuotesItem,
        UiDataGridItem,
        UiDataGrid,
        UiButtonNew, UiDropdown, UiDropdownItem, UiContainer, AutoresizableTextarea
    },
    props: {
        item: Object,
        edit: Function,
        removeItem: Function,
        addItem: Function,
        contacts: Array(),
        packageReference: null,
    },
    computed: {
        tabs() {
            return [
                {value: 'overview', label: 'Overview'},
                {value: 'files', label: 'Files'},
            ]
        },
    },
    data() {
        let supplierQuoteClipboardData = []
        try {
            supplierQuoteClipboardData = remoteStorage.getItem('supplier-quote-clipboard') ? JSON.parse(remoteStorage.getItem('supplier-quote-clipboard')) : []
        } catch (e) {
            //continue on JSON ERROR
        }

        return {
            supplierQuote: {},
            supplierQuoteClipboard: supplierQuoteClipboardData,
        }
    },
    methods: {
        openDeleteModal() {
            const title = 'Are you sure you want to remove this supplier quote?'
            const description = 'You are removing supplier quote #' + this.item.id + '. Are you sure you want to do this?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.item.delete(this.item.id)
                this.removeItem(this.item)

            });
        },
        async duplicate() {
            let data = (await SupplierQuote.find(this.item.id)).getFormAttributes();
            const sq = await SupplierQuote.create(this.packageReference, data);

            this.addItem(sq, 0, (items) => {
                items.sort((a, b) => (a.date < b.date) ? 1 : ((b.date < a.date) ? -1 : 0));
            });
            this.edit(sq);
        },
        copy() {
            this.supplierQuoteClipboard = [cloneDeep(this.item)]
            remoteStorage.setItem('supplier-quote-clipboard', JSON.stringify(this.supplierQuoteClipboard))
        }
    },
    async mounted() {
        this.supplierQuote = await SupplierQuote.find(this.item.id);
    }
}
</script>
